<div class="nlc-card">
  <div class="nlc-card-header">
    <div class="nlc-card-icon">
      <mat-icon>person</mat-icon>
    </div>
    <div class="nlc-card-title-section">
      <h3>Kontakt</h3>
    </div>
  </div>
  <div class="nlc-card-content" *ngIf="contact$ | async as contact">
    <div class="nlc-info-row" *ngIf="contact.firstName || contact.lastName">
      <span class="nlc-info-label">Name</span>
      <span class="nlc-info-value">{{ contact.firstName }} {{ contact.lastName }}</span>
    </div>
    <div class="nlc-info-row" *ngIf="contact.email">
      <span class="nlc-info-label">E-Mail</span>
      <span class="nlc-info-value">{{ contact.email }}</span>
    </div>
    <div class="nlc-info-row" *ngIf="contact.callThrough">
      <span class="nlc-info-label">Durchwahl</span>
      <span class="nlc-info-value">{{ contact.callThrough }}</span>
    </div>
    <div class="nlc-info-row" *ngIf="contact.mail">
      <span class="nlc-info-label">Email</span>
      <span class="nlc-info-value">{{ contact.mail }}</span>
    </div>
  </div>
</div>
